import { useTranslation } from 'react-i18next';
import type { FlatfinderData } from 'realitiq-utils/src/flatfinder';
import { Modal } from '@/components/modals/new/modal';
import { FlatfinderSettings } from './settings-panel';

export function FlatfinderSettingsModal({
  busy,
  data,
  open,
  saveError,
  onDismiss,
  onSave,
}: {
  busy: boolean;
  data: FlatfinderData;
  open: boolean;
  saveError: string | null;
  onDismiss: () => void;
  onSave: (status: 'draft' | 'published', contact: string | null) => void;
}) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <Modal
      isOpen
      open={() => {}}
      dismiss={onDismiss}
      dismissDisabled={busy}
      title={t('sharing')}
      className="max-h-[90dvh] max-w-2xl overflow-y-auto rounded-lg border border-primary-light/20 shadow-lg"
    >
      <Modal.Body>
        <FlatfinderSettings
          key={`${data.id}-${data.contactLink}`}
          data={data}
          busy={busy}
          saveError={saveError}
          onSave={onSave}
        />
      </Modal.Body>
    </Modal>
  );
}
